import { fileAPI } from './api';

export const uploadFileToS3 = async (file, folder = 'thumbnails', onProgress = null) => {
  if (!file) {
    throw new Error('No file provided');
  }

  try {
    const result = await fileAPI.upload(file, folder, onProgress);
    return {
      success: true,
      url: result.url,
      key: result.key,
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    throw new Error(`Failed to upload file: ${error.message}`);
  }
};

export const deleteFileFromS3 = async (key) => {
  if (!key) {
    throw new Error('Missing key');
  }

  try {
    const result = await fileAPI.deleteFile(key);
    return result;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw new Error(`Failed to delete file: ${error.message}`);
  }
};

export const getSignedUploadUrl = async () => {
  // Presigned URLs are no longer needed — uploads go through backend
  throw new Error('getSignedUploadUrl is deprecated. Use uploadFileToS3 instead.');
};

export const listFilesFromS3 = async (folder = 'thumbnails', maxKeys = 100) => {
  try {
    const folderPath = folder.endsWith('/') ? folder : `${folder}/`;
    const response = await fileAPI.list(folderPath);
    const objects = response.objects || [];

    const files = objects
      .filter(obj => !obj.isFolder)
      .map(file => ({
        key: file.fullKey,
        url: fileAPI.getDownloadUrl(file.fullKey),
        lastModified: file.lastModified,
        size: file.size,
        name: file.key
      }))
      .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified))
      .slice(0, maxKeys);

    return {
      success: true,
      files,
      totalCount: files.length,
      isTruncated: false
    };
  } catch (error) {
    console.error('Error listing files:', error);
    throw new Error(`Failed to list files: ${error.message}`);
  }
};
